<template>
  <section
    v-if="numberOfAddOns > 0"
    :class="[openClass, 'expandable_section', 'add-on-group']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ $t('checkout.addOn.raceDayExtra') }}
    </h2>

    <div class="expandable_content">
      <table class="table add-ons-table">
        <thead class="thead-dark">
          <tr>
            <th><div class="side-div" />Add-ONS</th>
            <th>DESCRIPTION</th>
            <th>PRICE</th>
            <th>QTY</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <AddOn
            v-for="item in addOnItems"
            :key="item.id"
            :item="item"
            :currency="currency"
            :rate="rate"
            @refresh-add-ons="addOnChanged"
          />
        </tbody>
      </table>
      <button
        class="btn btn-primary continue-button"
        @click="updateSection(sectionNext)"
      >
        {{ $t('cookie.continue') }}
      </button>
    </div>
  </section>
</template>

<script>
import AddOn from './add_on'
import Api from '../../cart/cart_api'
import { mapMutations } from 'vuex'

export default {
  components: {
    AddOn
  },

  props: ['currentsection', 'number'],

  data() {
    return {
      addOnAddedText: '',
      addOnClass: 'hidden',
      addOnItems: [],
      currency: 'USD',
      rate: 1.0,
      sectionName: 'addOn',
      sectionNext: 'address'
    }
  },

  computed: {
    numberOfAddOns() {
      return this.addOnItems.length
    },

    selected() {
      return this.currentsection == this.sectionName
    },

    openClass() {
      return (this.selected) ? 'open' : ''
    }

  },

  created() {
    this.getAddOns().then(() => {
      if (this.numberOfAddOns > 0) {
        this.updateSection(this.sectionName)
      }
    })
  },

  methods: {
    ...mapMutations('checkout', [
      'updateSection',
      'updateSectionNumber'
    ]),
    addOnChanged(item) {
      if (item.display_name) {
        this.addOnAddedText = this.$t('checkout.addOn.added', { name: item.display_name })
        this.addOnClass = 'add-on-message'
      } else if (item.errors) {
        this.addOnClass = 'add-on-message error'
        this.addOnAddedText = item.errors
      } else {
        this.addOnClass = 'hidden'
        this.addOnAddedText = ''
      }

      this.getAddOns()
    },

    getAddOns() {
      return Api.getAddOnItems().then(response => {
        if (response.a_la_cartes) {
          this.addOnItems = response.a_la_cartes
          this.currency = response.currency
          this.rate = response.rate
        }

        this.refreshAddOns()
      })
    },

    refreshAddOns() {
      // this.$emit('refresh-add-ons', this.numberOfAddOns)
      this.updateSectionNumber(this.numberOfAddOns)
    }
  }
}
</script>
